<footer>
    <p>Copyright 2021. OSHO Manan Neo-Sannyas Commune.</p>
</footer>